import React from 'react';
import { Grid, Link, Typography } from "@mui/material";
import { Box } from "@mui/system";
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import GitHubIcon from '@mui/icons-material/GitHub';

export function Footer() {
    return (
        <footer style={{ width: '100%', borderTop: '1px solid #e2e8f0', marginTop: '40px' }}>
            <Grid item xs={12} justifyContent="space-between" display="flex" height={80} alignItems="center">
                <Typography variant="body2" color="text.secondary">
                    © {new Date().getFullYear()} Damon Ye
                </Typography>
                <Box sx={{ display: 'flex', gap: '8px' }}>
                    <Link
                        href="https://www.linkedin.com/in/damonye"
                        sx={{
                            color: '#64748b',
                            transition: 'color 0.2s ease',
                            '&:hover': { color: '#0077b5' }
                        }}
                    >
                        <LinkedInIcon />
                    </Link>
                    <Link
                        href="https://github.com/dye784/"
                        sx={{
                            color: '#64748b',
                            transition: 'color 0.2s ease',
                            '&:hover': { color: '#1e293b' }
                        }}
                    >
                        <GitHubIcon />
                    </Link>
                    <Link
                        href="mailto:damonye91@gmail.com"
                        sx={{
                            color: '#64748b',
                            transition: 'color 0.2s ease',
                            '&:hover': { color: '#2563eb' }
                        }}
                    >
                        <EmailOutlinedIcon />
                    </Link>
                </Box>
            </Grid>
        </footer>
    );
}